import { Header } from 'components/molecules';
import { ListUserTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const ListUserPage = () => {
  return (
    <>
      <Header
        title="Usuarios"
        subtitle="Crea, edita, lista y elimina usuarios"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <ListUserTemplate />
    </>
  );
};

export default withAuth(ListUserPage);
